import React from 'react';
import { products } from '../mock';
import { Star, Sparkles, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import ProductCard from './ProductCard';

const Products = () => {
  const featuredProduct = products.find((p) => p.featured);
  const otherProducts = products.filter((p) => !p.featured);

  return (
    <section id="products" className="py-24 bg-[#f7f5f2]">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a1918] mb-4">
            Our Premium Collection
          </h2>
          <p className="text-lg text-[#736c64] max-w-2xl mx-auto">
            Unique photo booths designed to create unforgettable experiences
          </p>
        </div>

        {/* Featured Product - iMIRROR with Vertical Image */}
        {featuredProduct && (
          <div className="mb-20">
            <Card className="overflow-hidden bg-gradient-to-br from-[#1a1918] to-[#2d2826] border-[#d4af37] border-2 hover-lift">
              <CardContent className="p-0">
                <div className="grid lg:grid-cols-5 gap-0">
                  {/* Vertical Image Column */}
                  <div className="lg:col-span-2 relative overflow-hidden flex items-center justify-center bg-gradient-to-br from-[#2d2826] to-[#1a1918] p-8">
                    <img
                      src={featuredProduct.image}
                      alt={featuredProduct.name}
                      className="w-full max-w-md h-auto object-contain transform hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute top-4 right-4 bg-[#d4af37] text-[#1a1918] px-4 py-2 rounded-full font-bold flex items-center space-x-2">
                      <Star className="w-4 h-4 fill-current" />
                      <span>Bestseller</span>
                    </div>
                  </div>
                  
                  {/* Content Column */}
                  <div className="lg:col-span-3 p-8 md:p-12 flex flex-col justify-center">
                    <div className="flex items-center space-x-2 mb-4">
                      <Sparkles className="w-6 h-6 text-[#d4af37]" />
                      <span className="text-[#d4af37] font-semibold text-sm uppercase tracking-wider">
                        {featuredProduct.tagline}
                      </span>
                    </div>
                    <h3 className="text-4xl md:text-5xl font-bold text-white mb-4 gradient-text">
                      {featuredProduct.name}
                    </h3>
                    <p className="text-[#bbb5ae] text-xl mb-6 font-semibold">
                      {featuredProduct.description}
                    </p>
                    <p className="text-[#bbb5ae] text-base mb-6 leading-relaxed">
                      {featuredProduct.fullDescription}
                    </p>
                    
                    {/* Features List */}
                    <div className="space-y-3 mb-8">
                      {featuredProduct.features.map((feature, index) => (
                        <div key={index} className="flex items-start space-x-3">
                          <Check className="w-5 h-5 text-[#d4af37] mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="text-white font-semibold">{feature.title}</h4>
                            <p className="text-[#bbb5ae] text-sm">{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    <button className="self-start bg-gradient-to-r from-[#d4af37] to-[#ffd700] text-[#1a1918] px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 shine-effect">
                      Learn More & Inquire
                    </button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}

        {/* Other Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {otherProducts.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;